import * as React from 'react';

export interface INewsLetterBoxProps {
    buttonText: string;
    regionName: string;
    newsLetterSubscribeText: string;
    newsLetterSubscribeHeading?: string;
    showMobileImage?: boolean;
    yellowUnderlineHeading?: boolean;
}

interface INewsLetterBoxState {
    email: string;
    subscribed: boolean;
    valid: boolean;
    errortext: string;
}

export class NewsLetterBox extends React.Component<INewsLetterBoxProps, INewsLetterBoxState> {
    constructor(props: INewsLetterBoxProps) {
        super(props);
        this.state = { email: '', subscribed: false, valid: true, errortext: '' };
    }

    public render(): JSX.Element {
        const region = this.props.regionName.toLowerCase() === 'gbg' ? 'Göteborg' : 'Stockholm';
        let contentText =
            this.props.newsLetterSubscribeText == null ||
            this.props.newsLetterSubscribeText == undefined ||
            this.props.newsLetterSubscribeText.length === 0
                ? 'Nyhetsbrevet med trafikstörningar som kan vara bra att känna till för dig som är trafikant i ' +
                  region +
                  '. Din e-postadress sparas, men enbart för utskick från Trafiken.nu.'
                : this.props.newsLetterSubscribeText;
        if (!contentText.endsWith('.')) {
            contentText += '.';
        }

        return (
            <div className="news-letter-box">
                <h2 className={this.props.yellowUnderlineHeading ? 'h5 yellow-border-bottom' : ''}>
                    {this.props.newsLetterSubscribeHeading != null ? this.props.newsLetterSubscribeHeading : 'Prenumerera på Veckans trafik'}
                </h2>
                <p className="news-letter-box__text">
                    <span>{contentText}</span>
                    {this.props.showMobileImage && (
                        <img src="/images/nyhetsbrev-mobil.webp?class=thumbnail" width="76" alt="Mobiltelefon med Veckans trafik" />
                    )}
                </p>
                {this.state.subscribed ? (
                    <div className="news-letter-box__response-ok">Tack! Ett bekräftelsemejl har skickats till: {this.state.email}</div>
                ) : (
                    <div className="input-group news-letter-box__input-group  subscribe-form">
                        <input
                            aria-label="E-postadress för nyhetsbrevet"
                            type="email"
                            className="form-control news-letter-box__form-control"
                            placeholder="E-postadress"
                            onChange={this.onUpdate.bind(this)}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-dark" onClick={this.handleSubscribe.bind(this)} type="button">
                                {this.props.buttonText}
                            </button>
                        </div>
                    </div>
                )}
                {this.state.valid ? null : (
                    <div className="news-letter-box__response-faild" dangerouslySetInnerHTML={{ __html: this.state.errortext }}></div>
                )}
            </div>
        );
    }

    private onUpdate(event) {
        const data = { email: event.target.value, valid: true };
        this.setState(data);
    }

    private handleSubscribe() {
        if (this.validateEmail(this.state.email)) {
            fetch('/api/newsletter/subscribe?email=' + encodeURIComponent(this.state.email) + '&region=' + this.props.regionName)
                .then((response) => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        this.setState({
                            valid: false,
                            errortext:
                                'Det gick inte registrera e-postadressen. Om problemet kvarstår, kontakta ' +
                                (this.props.regionName.toLowerCase() === 'gbg' ? 'goteborg@trafiken.nu.' : 'stockholm@trafiken.nu.'),
                        });
                    }
                })
                .then((response) => {
                    if (response !== undefined) {
                        if (response === '') {
                            this.setState({ subscribed: true });
                        } else {
                            this.setState({ valid: false, errortext: response });
                        }
                    }
                });
        } else {
            this.setState({ valid: false });
        }
    }

    private validateEmail(email: string): boolean {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}
